import { style } from "@vanilla-extract/css";

import type { BorderVariant } from "../types";
import { bordersDefinition } from "../borders";

export const borders = Object.fromEntries(
  Object.entries(bordersDefinition).map(([name, rules]) => [
    name,
    style(rules),
  ]),
) as Record<BorderVariant, string>;
